module.exports = __webpack_public_path__ + "static/media/sort.3f5e12b1.svg";